import _ from 'lodash';
import templateStr from 'text!./templates/custom-quote.html';
import 'edge/quoteandbind/common/app';
import appFeatures from 'effective-features!';

const BLOCKS_QUOTE = 'BlocksQuote';
const BLOCKS_QUOTE_RELEASE = 'BlocksQuoteRelease';

function isUwIssueBlockingQuote(uwIssueOnOffering) {
    return _.includes([BLOCKS_QUOTE, BLOCKS_QUOTE_RELEASE], uwIssueOnOffering.currentBlockingPoint);
}

function blockingUwIssueText($filter, blockedQuotes = []) {
    const displayableOfferedQuotes = blockedQuotes.filter(offeringName => offeringName !== 'CUSTOM');
    if (displayableOfferedQuotes.length > 0) {
        return $filter('translate')('integration.quoteandbind.underwriting-issues.We cannot show a quote because it has underwriting issues');
    }
    return $filter('translate')('integration.quoteandbind.underwriting-issues.We cannot show a quote for the following offerings because they have underwriting issues:', {
        blockedOfferings: displayableOfferedQuotes.join(',')
    });
}

export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        require: 'gwQnbCustomQuote',
        scope: {
            quoteData: '=',
            buy: '=',
            error: '='
        },
        controller: ['$scope', '$filter', 'StateUtils', 'UnderwritingIssuesUtil', 'FlowValidationService', 'FLOW_UNDERWRITING_ISSUE',
            function ($scope, $filter, StateUtils, UnderwritingIssuesUtil, FlowValidationService, FLOW_UNDERWRITING_ISSUE) {

                const uwIssuesBlockingQuote = FlowValidationService.getDisplayableErrors({types: [FLOW_UNDERWRITING_ISSUE]})
                    .filter(isUwIssueBlockingQuote);
                const firstOfferedQuote = _.get($scope.quoteData, 'offeredQuotes[0]');
                const submission = $scope.quoteData.submission;
                const blockedQuotes = UnderwritingIssuesUtil.getBlockedQuotes(uwIssuesBlockingQuote);

                $scope.uwIssuesBlockingQuote = uwIssuesBlockingQuote;
                $scope.hasUwIssuesBlockingQuote = uwIssuesBlockingQuote.length > 0;
                $scope.submission = submission;
                $scope.hasOfferedQuote = !!firstOfferedQuote;
                $scope.blockedQuotes = blockedQuotes;
                $scope.uwIssuesByOffering = UnderwritingIssuesUtil.getUwIssuesByOffering(uwIssuesBlockingQuote);
                $scope.showUwIssueDetails = appFeatures.gatewayquoteandbind;
                $scope.submissionNumber = submission.quoteID;
                $scope.blockingUwIssueText = blockingUwIssueText($filter, blockedQuotes);

                // convert OfferingDTO to CustomQuotedTO structure
                $scope.customQuote = {
                    quote: firstOfferedQuote,
                    coverages: _.get(firstOfferedQuote, 'lobs'),
                    quoteID: submission.quoteID.value,
                    sessionUUID: submission.sessionUUID.value,
                    periodStart: submission.baseData.periodStartDate.value,
                    periodEnd: submission.baseData.periodEndDate.value
                };

                $scope.offerings = {
                    standardOffering: $scope.quoteData.baseOffering,
                    customOffering: firstOfferedQuote
                };


                /**
                 * Method used by wizard ribbon to move between steps.
                 *
                 * @param {Object} editCoverageStep
                 */
                $scope.selectStep = function (editCoverageStep) {
                    StateUtils.jumpToTheStep(editCoverageStep);
                };

                $scope.buyQuote = function () {
                    $scope.buy.apply(null, arguments);
                };

                $scope.buyQuoteWithDefaultParams = () => {
                    const termInMonths = $scope.customQuote.quote.premium.termMonths;
                    $scope.buy($scope.customQuote.quote, termInMonths);
                };

            }
        ]
    };
}];